import React from "react";
import { Container } from "react-bootstrap";
import "./InnerPage.css";
import { useLocation, useNavigate } from "react-router-dom";
import logo from "../../../../Asset/blog/logo-web.png";
import eye from "../../../../Asset/blog/eye.svg";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import blogData from "../../../../blog";

const InnerPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleNavigateHome = () => {
    navigate("/");
  };
  const handleNavigateBlog = () => {
    navigate("/Blog");
  };

  const { title } = location.state || {};

  const innerBlog = blogData.find((item) => item.title === title);

  return (
    <>
      <section className="inner-page-blog-section">
        <Container>
          <ul className="top-nav-blog">
            <li>
              <p onClick={handleNavigateHome}>Home</p>
              <span>/</span>
            </li>
            <li>
              <p onClick={handleNavigateBlog}>Blog</p>
              <span>/</span>
            </li>
            <li className="active" style={{ color: "var(--primary-color)" }}>
              <p>&nbsp; {innerBlog.title}</p>
            </li>
          </ul>
          <div className="blog-details-block">
            <div className="post-featured-img">
              <img src={innerBlog.innerImg} alt="InnerImage" />
            </div>
            <div className="single-contnet">
              <div className="row meta-social-block">
                <div className="col-auto me-auto">
                  <div className="post-meta">
                    <div className="post-avatar">
                      <img src={logo} alt="avatar" />
                    </div>
                    <div className="post-data">
                      <div className="post-user-name">Codeffi Team</div>
                      <div className="single-wrap">
                        <span className="post-date">{innerBlog.date}</span>
                        <div className="post-views">
                          <div className="img">
                            <img src={eye} alt="card" />
                          </div>
                          <div className="view_count">
                            {innerBlog.views} <span>Views</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="share-social-icons">
                    <ul className="social-media-icons">
                      <li>
                        <p>
                          <FaLinkedinIn />
                        </p>
                      </li>
                      <li>
                        <p>
                          <FaFacebookF />
                        </p>
                      </li>
                      <li>
                        <p>
                          <FaTwitter />
                        </p>
                      </li>
                      <li>
                        <p>
                          <FaWhatsapp />
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {innerBlog.innerBlogData.map((section, index) => (
                <div key={index} className="entry-content">
                  {section.title && (
                    <h1 className="post-title">{section.title}</h1>
                  )}
                  {section.subtitle && <h2>{section.subtitle}</h2>}
                  {section.paragraphs.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                  <div className="post-featured-img">
                    {section.image && (
                      <img
                        src={section.image}
                        alt="featured"
                        className="w-100"
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default InnerPage;
